import { isRenderedInIFrame } from 'helper/js/helper';
import useGeneratedDocumentTitle from 'helper/js/hooks/use-generated-title';

export default function PageTitle() {
  const generatedTitle = useGeneratedDocumentTitle();

  if (isRenderedInIFrame()) {
    return <h2 className="sr-only">{generatedTitle}</h2>;
  }

  return <h1 className="sr-only">{generatedTitle}</h1>;
}
